import React from 'react';
import { useLocation } from 'react-router-dom';
import ConfluencePage from '../ConfluencePage/ConfluencePage';
import '../../css/confluence.css';

const Page = () => {
  const location = useLocation();
  const pageName = new URLSearchParams(location.search).get('title');
  return <ConfluencePage pageName={pageName} />;
};

export default Page;
